<template>
  <div id="about" class="about-me">
    <h2>О нас</h2>
    <div class="about-me__content">
      <div class="about-me__photo-block">
        <img src="../assets/ivan.jpg" alt="Ivan" style="width: 120px; height: 120px;">
        <p class="about-me__name">Иван</p>
        <small style="color: #777; margin-bottom: 8px;">исполнительный директор</small>
        <a href="tel:+38268454710">+382 (68) 454-710</a>
      </div>
      <div class="about-me__description">
        Мы занимаемся профессиональной химчисткой и клинингом в Черногории,
        используя современное оборудование Kärcher и безопасную химию.<br><br>
        <strong>Для тех, кто заказывает наши услуги:</strong><br>
        • выезд по всему побережью Черногории<br>
        • индивидуальный подбор химии<br>
        • ответим на все интересующие вас вопросы<br><br>
        Цены на клининг и химчистку максимально демократичные, а качественно - отличное. Как такое может быть?
        <strong>Звоните - узнаете</strong> 😊
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

.about-me {
  margin-bottom: 40px;

  &__content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 0 80px;
    max-width: 1080px;
  }

  &__photo {
    width: 240px;
    height: 240px;
    box-shadow: 0 0 15px 2px rgba(0, 0, 0, 0.15);
    object-fit: contain;
    border: 10px solid #fff;
    border-radius: 50%;
  }

  &__photo-block {
    flex: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
      border-radius: 120px;
    }
  }

  &__name {
    font-size: 22px;
    line-height: 28px;
    margin: 20px 0 4px;
    font-weight: 900;
    text-align: center;
  }

  &__description {
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    padding: 20px 0 20px 60px;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .about-me {
    &__photo {
      width: 120px;
      height: 120px;
      border-width: 4px;
    }

    &__content {
      padding: 0 10px;
      flex-direction: column;
    }

    &__description {
      /*text-align: center;*/
      padding: 20px;
    }
  }
}
</style>
